import type { FaireProductEntity } from "../../entity_types/product";

export const p_wadws4e9b9: FaireProductEntity = {
  token: "p_wadws4e9b9",
  type: "product",
  name: "3 pc Hand made Love altar by Peruvian artist H156",
  brandToken: "b_yrt8x5m6m6",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f781bb9636892fc741d178cd29e7898db9ff31873abe8a7bb6e8c44028c99d92.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9cb48aa8df0e4ec3d0986a8ce4e183b72718b674d434ff066efe9449dfaadab3.jpeg",
    "https://cdn.faire.com/fastly/5f576c775be2aae4c7d854c8322d2315fb2652525beda624f549c61bc99b05ff.jpeg",
    "https://cdn.faire.com/fastly/40790d17584294c64428fe0d3eccc866dc20c7693c41acdaa5fdcb12b2333a5f.jpeg",
    "https://cdn.faire.com/fastly/1635351d3f26e8586d09a338c03b52e22459f753041dce8ec29cb824d65c71b1.jpeg",
    "https://cdn.faire.com/fastly/11f6d59e02ed6232157616665b215da804bf78c7fd4390da9adc6ccd0af73332.jpeg",
    "https://cdn.faire.com/fastly/9e740591eb8009c441987f5ec93bf33a0a24616c4e25c75ddb27965827203f78.jpeg",
    "https://cdn.faire.com/fastly/1c997dfbca602f21b08cc6e73a03bb5a7da3e3cf5c6cee5281c012e4b27d603d.jpeg",
  ],
  priceDollars: 72.06,
  description:
    '3 pc Hand made Love altar by Peruvian artist H156\n\nThis is the exact set you will receive\n\nAPprox 4.1" - 5.6"\n\n\n',
  tags: [],
  msrpDollars: 144.11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:47.115Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
